import { FC } from 'react'

import { ButtonProps } from '../../../types'

const Button: FC<ButtonProps> = ({ value, className, onClick, children, ...rest }) => {
  return (
    <button value={value} className={`${className} light`} onClick={onClick} {...rest}>
      {children}
    </button>
  )
}

export default Button
